import { render, staticRenderFns } from "./fixes.vue?vue&type=template&id=05d6c981&scoped=true&"
import script from "./fixes.vue?vue&type=script&lang=js&"
export * from "./fixes.vue?vue&type=script&lang=js&"
import style0 from "./fixes.vue?vue&type=style&index=0&id=05d6c981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6c981",
  null
  
)

export default component.exports